import { BREAKPOINTS } from "@/constants/Core";
import { memo } from '@fantastic-utils/memo';
import inRange from "lodash/inRange";
import { Platform } from "react-native";

export const getDeviceBreakpoint = memo(width => ({
    isDesktop: width >= BREAKPOINTS.DESKTOP,
    isTablet: inRange(width, BREAKPOINTS.PHONE, BREAKPOINTS.TABLET),
    isMobile: inRange(width, 0, BREAKPOINTS.PHONE),
    isMobileOrTablet: inRange(width, 0, BREAKPOINTS.TABLET),
    isNative: Platform.OS === 'ios' || Platform.OS === 'android',
}));